import React from "react";
import dayjs, { Dayjs } from 'dayjs';

import { TailwindDatePicker } from "../../../Tailwind";
import { useEditorStore } from "../../../../shared/stores/useEditorStore";

export default function CustomDatePicker({ item, currentValue, handleChange, readOnly = false }: { item: any; currentValue: any; handleChange: any; readOnly?: boolean }) {
    const isReadOnly = !useEditorStore(s => s.userRights).right_to_write;

    const triggerHandleChange = (newValue: Date | null) => {
        // Convert Date to dayjs before passing to handleChange
        const dayjsValue = newValue ? dayjs(newValue) : null;

        if (dayjsValue === null || (dayjsValue.isValid() && dayjsValue.year() > 1900)) {
            handleChange(dayjsValue)
        }
    }

    // Convert dayjs to Date for TailwindDatePicker
    const dateValue = currentValue && dayjs.isDayjs(currentValue)
        ? currentValue.toDate()
        : currentValue instanceof Date
            ? currentValue
            : null;

    return (
        <div className="mb-1">
            <TailwindDatePicker
                value={dateValue}
                onChange={triggerHandleChange}
                disabled={isReadOnly}
                readOnly={readOnly}
                className="w-[200px]"
            />
        </div>
    )
}
